import { useDisclosure } from '@mantine/hooks';
import { useMemo } from 'react';
import { MultiSelectionToggleGlobal } from 'src/components/common/MultiSelect/Toggle/MultiSelectionToggleGlobal';
import { SaleEventFilterDrawer } from 'src/components/Listings/InventoryEventPage/InventoryEventPageRework/Mobile/SortAndFilter/SaleEventFilterDrawer';
import { SaleEventSortingContent } from 'src/components/Listings/InventoryEventPage/InventoryEventPageRework/Mobile/SortAndFilter/SaleEventSortingContent';
import { SaleSearchBox } from 'src/components/Sales/SaleFilterBar/SaleSearchBox';
import { useMobileDrawerContext } from 'src/contexts/MobileDrawerContext';
import { useMobileSalesSortAndFilterContext } from 'src/contexts/MobileSortAndFilterContext/MobileSalesSortAndFilterContext';
import { useMultiSelectionContext } from 'src/contexts/MultiSelectionContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { BadgedIcon } from 'src/core/ui/BadgedIcon/BadgedIcon';
import { SortIcon } from 'src/svgs/SortIcon';
import { FilterIcon } from 'src/svgs/Viagogo';

import * as styles from './EventFilterBar.css';

export const EventFilterBar = () => {
  const { openWithContent } = useMobileDrawerContext();
  const { hasSortingChanged, hasFilterApplied } =
    useMobileSalesSortAndFilterContext();

  const { selectionMode } = useMultiSelectionContext();
  const [show, { open, close }] = useDisclosure(false);

  const isInBulk = useMemo(
    () => Boolean(selectionMode?.mode),
    [selectionMode?.mode]
  );

  return (
    <>
      <Stack
        alignItems="center"
        gap="m"
        className={styles.eventFilterContainer}
      >
        <div style={{ display: 'flex', flex: `1 1 auto` }}>
          <SaleSearchBox minWidth={'unset'} />
        </div>
        <div
          className={styles.eventFilterButton}
          onClick={() =>
            !isInBulk &&
            openWithContent(<SaleEventSortingContent />, { size: '60%' })
          }
        >
          <BadgedIcon
            icon={<SortIcon fill={vars.color.textSecondary} />}
            withBadge={hasSortingChanged}
          />
        </div>
        <div
          className={styles.eventFilterButton}
          onClick={() => !isInBulk && open()}
        >
          <BadgedIcon
            icon={<FilterIcon fill={vars.color.textSecondary} />}
            withBadge={hasFilterApplied}
          />
        </div>
        <MultiSelectionToggleGlobal variant="button" />
      </Stack>
      <SaleEventFilterDrawer show={show} onClose={close} />
    </>
  );
};
